import React from 'react'
import {TouchableOpacity} from 'react-native'
import Svg, {Path} from 'react-native-svg'

type Props = {
  /** The onclick handler for the close button. */
  onClick: Function,
}

/** 
 * Image viewer close button 
 * @component
 */
export const CloseButton = ({onClick}: Props) => {
  return (
     <TouchableOpacity
        onPress={onClick}
      >
        <Svg
          width="36px"
          height="36px"
          viewBox="0 0 18 18"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Path
            fillRule="evenodd"
            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
          />
        </Svg>
      </TouchableOpacity>
    
  )
}